export default __webpack_public_path__ + "static/media/customer-oriented.17c13390.jpg";